module.exports = __webpack_public_path__ + "img/why-hro.985cc186.png";